var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { ref: "navSidebarGroup", class: _vm.classes, on: { click: _vm.onClick } },
    [
      _vm.$slots.tooltip && _vm.$refs.navSidebarGroup
        ? _c(
            "NavSidebarTooltip",
            _vm._b(
              { attrs: { "class-name": "nav-sidebar-group__tooltip" } },
              "NavSidebarTooltip",
              _vm.tooltipBindings,
              false
            ),
            [_vm._t("tooltip")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.headingClasses }, [
        _vm.$slots.icon
          ? _c(
              "span",
              { staticClass: "nav-sidebar-group__icon" },
              [_vm._t("icon")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "h1",
          { class: _vm.textClasses },
          [_vm.$slots.text ? _vm._t("text") : _vm._e()],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "nav-sidebar-group__items" },
        [_vm._t("items")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010c4cf3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010c4cf3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/NavSidebarGroup.vue
// module id = yMGR
// module chunks = 5